export default __webpack_public_path__ + "static/media/Tag.9261fad3.png";